(function () {
  if (window.JSQQuoteSubmitHandoffV1) return;
  window.JSQQuoteSubmitHandoffV1 = true;

  var key = 'jsqQuoteSubmitPendingV1';
  var phone = '+15098678979';

  function clean(value, fallback) {
    value = String(value || '').replace(/\s+/g, ' ').trim();
    return value || fallback || '';
  }

  function html(value) {
    return clean(value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function byId(id) {
    return document.getElementById(id);
  }

  function quoteDetails(form) {
    function field(name, fallback) {
      var input = form.querySelector('[name="' + name + '"]');
      return clean(input && input.value, fallback);
    }

    return {
      at: Date.now(),
      price: clean(byId('jsqPrice') && byId('jsqPrice').textContent, field('contact[Quote Price]', 'your estimate')),
      service: clean(byId('jsqServiceText') && byId('jsqServiceText').textContent, field('contact[Quote Service]', 'mobile detailing')),
      vehicle: clean(byId('jsqVehicleText') && byId('jsqVehicleText').textContent, field('contact[Vehicle Type]', 'your vehicle')),
      condition: clean(byId('jsqConditionText') && byId('jsqConditionText').textContent, field('contact[Vehicle Condition]', 'condition review')),
      location: field('contact[Location]', ''),
    };
  }

  function quoteIncomplete(details) {
    var price = clean(details && details.price).toLowerCase();
    var service = clean(details && details.service).toLowerCase();
    var vehicle = clean(details && details.vehicle).toLowerCase();
    var condition = clean(details && details.condition).toLowerCase();
    return !price ||
      /pick|choose|select|finish|incomplete|quote/.test(price) ||
      !service ||
      /choose|select|package/.test(service) ||
      !vehicle ||
      vehicle === '-' ||
      !condition ||
      condition === '-' ||
      /choose|select|needs package/.test(condition);
  }

  function installStyle() {
    if (document.getElementById('jsq-quote-submit-handoff-style')) return;
    var style = document.createElement('style');
    style.id = 'jsq-quote-submit-handoff-style';
    style.textContent = '.jsq-submit-success{width:min(900px,calc(100vw - 28px));margin:24px auto;padding:18px;border:1px solid rgba(197,157,95,.45);border-radius:18px;background:linear-gradient(135deg,rgba(197,157,95,.18),rgba(8,8,8,.92));color:#fff;box-shadow:0 18px 42px rgba(0,0,0,.28)}.jsq-submit-success strong{display:block;margin:0 0 8px;color:#fff;font-size:24px;line-height:1.1}.jsq-submit-success p{margin:0;color:rgba(255,255,255,.78);font-size:15px;line-height:1.45}.jsq-submit-success-actions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:14px}.jsq-submit-success-actions a{display:flex;align-items:center;justify-content:center;min-height:48px;border:1px solid rgba(255,255,255,.18);border-radius:12px;color:#fff;text-decoration:none;font-weight:900}.jsq-submit-success-actions a:first-child{background:#c59d5f;color:#080808;border-color:#c59d5f}@media(max-width:700px){.jsq-submit-success{margin:16px auto;padding:16px;border-radius:16px}.jsq-submit-success strong{font-size:22px}.jsq-submit-success-actions{grid-template-columns:1fr}}';
    document.head.appendChild(style);
  }

  function storePending(form, details) {
    try {
      sessionStorage.setItem(key, JSON.stringify(details || quoteDetails(form)));
    } catch (error) {}
  }

  function setSendingState(form) {
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!button || button.dataset.jsqSending === 'true') return;
    button.dataset.jsqSending = 'true';
    button.dataset.jsqOriginalText = button.textContent || button.value || 'Send Quote Request';

    function apply() {
      if (!document.contains(button) || button.dataset.jsqSending !== 'true') return;
      if ('value' in button) button.value = 'Sending quote...';
      button.textContent = 'Sending quote...';
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    apply();
    [80, 220, 480, 900, 1600].forEach(function (delay) {
      setTimeout(apply, delay);
    });
    if (button.__jsqSendingTimer) clearInterval(button.__jsqSendingTimer);
    button.__jsqSendingTimer = setInterval(apply, 75);
    setTimeout(function () {
      if (!document.contains(button)) return;
      if (button.__jsqSendingTimer) clearInterval(button.__jsqSendingTimer);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if ('value' in button) button.value = button.dataset.jsqOriginalText;
      button.textContent = button.dataset.jsqOriginalText;
      button.dataset.jsqSending = 'false';
    }, 9000);
  }

  function contactPosted() {
    var params = new URLSearchParams(window.location.search);
    return params.has('contact_posted') || /contact_posted=true/i.test(window.location.href);
  }

  function pendingQuote() {
    try {
      var data = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!data || !data.at || Date.now() - data.at > 1000 * 60 * 20) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function showSuccess() {
    if (!contactPosted() || document.getElementById('jsqQuoteSubmitSuccess')) return;
    var data = pendingQuote();
    if (!data) return;
    installStyle();
    var card = document.createElement('section');
    var sms = 'sms:' + phone + '?&body=' + encodeURIComponent('Hi JS Mobile, I just sent a quote request for ' + data.service + ' at ' + data.price + '.');
    card.id = 'jsqQuoteSubmitSuccess';
    card.className = 'jsq-submit-success';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    card.innerHTML = '<strong>Quote request sent</strong><p>We received your ' + html(data.price) + ' ' + html(data.service) + ' request. JS Mobile will text or call to confirm the final price and appointment window before anything is booked.</p><div class="jsq-submit-success-actions"><a href="tel:' + phone + '">Call Now</a><a href="' + sms + '">Text JS Mobile</a></div>';
    (document.querySelector('main') || document.body).insertBefore(card, (document.querySelector('main') || document.body).firstChild);
    try {
      sessionStorage.removeItem(key);
    } catch (error) {}
    setTimeout(function () {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
  }

  function handleSubmit(event) {
    if (event.__jsqQuoteSubmitHandoffV1) return;
    var form = event.target;
    if (!form || form.id !== 'quoteRequestForm') return;
    event.__jsqQuoteSubmitHandoffV1 = true;
    if (form.reportValidity && !form.reportValidity()) return;
    var details = quoteDetails(form);
    if (quoteIncomplete(details)) return;
    storePending(form, details);
    setSendingState(form);
  }

  function bootSuccess() {
    showSuccess();
    setTimeout(showSuccess, 120);
    setTimeout(showSuccess, 700);
    setTimeout(showSuccess, 1600);
  }

  document.addEventListener('submit', handleSubmit, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootSuccess);
  else bootSuccess();
  window.addEventListener('pageshow', bootSuccess);
})();
